export default class AirTableForm {
  id: string;

  constructor(props: any) {
    this.id = props.id;
  }
}
